<template>
  <div class="alert alert-soft-danger fade show" role="alert">
    {{ message }}
  </div>
</template>

<script>
export default {
  name: "DashboardError",
  props: {
    message: String
  }
}
</script>

<style scoped></style>
